<!-- 主机安全加固方案 -->
<template>
  <div class="page_html">
    <div class="banner">
      <img
        src="@/assets/solution/enterprise/solution_banner.png"
        alt=""
      >
      <div class="banner_Title">
        <div class="title">
          {{ title }}
        </div>
        <div class="subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>

    <div
      v-for="item in constructor"
      :key="item.id"
      :class="item.background"
    >
      <div class="introduce">
        <p class="sub_title">
          {{ item.title }}
        </p>
      </div>
      <div class="contents">
        <div class="title">
          {{ item.subtitle }}
        </div>
        <ul
          v-for="list in item.lists"
          :key="list.index"
          class="content_lists"
        >
          <li>
            {{ list }}
          </li>
        </ul>

        <div
          v-if="item.hasImg"
          class="hasImg"
        >
          <div class="top">
            <div class="ImgContent">
              <img
                src="@/assets/solution/reforencement/pic1061.png"
                alt=""
              >
            </div>
            <div class="content">
              <div class="title">
                主机防火墙
              </div>
              <div class="text">
                防火墙承担主机系统入口的安保角色，过滤恶意访问流量，拒绝未授权流量。
              </div>
            </div>
            <div class="ImgContent">
              <img
                src="@/assets/solution/reforencement/pic1064.png"
                alt=""
              >
            </div>
            <div class="content">
              <div class="title">
                防暴力破解
              </div>
              <div class="text">
                灵活地自定义防暴力破解规则，对暴力破解行为进行检测，有效防御远程桌面和SSH登录的暴力破解。
              </div>
            </div>
          </div>
          <div class="lines">
            <div class="line" />
            <div class="line" />
            <div class="line" />
            <div class="line" />
          </div>

          <div class="bottom">
            <div class="content">
              <div class="title">
                主机防病毒
              </div>
              <div class="text">
                病毒查杀是安全检查站，检测恶意代码，防止恶意程序进入。
              </div>
            </div>
            <div class="ImgContent">
              <img
                src="@/assets/solution/reforencement/pic1062.png"
                alt=""
              >
            </div>
            <div class="content">
              <div class="title">
                入侵防御
              </div>
              <div class="text">
                对恶意网络攻击行为进行检测和拦截，辅以白名单功能，实现对漏洞攻击流量的防御。
              </div>
            </div>
            <div class="ImgContent">
              <img
                src="@/assets/solution/reforencement/pic1064.png"
                alt=""
              >
            </div>
          </div>
        </div>

        <div
          v-if="item.stereoscopic"
          class="stereoscopic"
        >
          <div class="stereoscopicLists">
            <div class="stereoscopicList blue">
              <div
                v-for="item in protect1"
                :key="item.id"
                class="protect"
              >
                <div class="title">
                  {{ item.title }}
                </div>
                <div class="text">
                  {{ item.text }}
                </div>
              </div>
            </div>
            <div class="stereoscopicList purple">
              <div
                v-for="item in protect2"
                :key="item.id"
                class="protect"
              >
                <div class="title">
                  {{ item.title }}
                </div>
                <div class="text">
                  {{ item.text }}
                </div>
              </div>
            </div>
            <div class="stereoscopicList babyBlue">
              <div
                v-for="item in protect3"
                :key="item.id"
                class="protect"
              >
                <div class="title">
                  {{ item.title }}
                </div>
                <div class="text">
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HostSecurityReinforcement',
  data() {
    return {
      title: '主机安全加固解决方案',
      subtitle: '据统计，80%以上企业被入侵后，需要数月时间才能发现入侵痕迹，而想要了解攻击者如何入侵成功以及入侵后开展了哪些行为，还需要数周调查时间，更是加长了响应处置的时长。相比于事件发生后花费大量的时间和精力去响应处置，做好主机日常安全防护才是更加有效的安全建设方向。',
      constructor: [
        {
          id: 1,
          title: '主机加固一基础保护级',
          subtitle: '主机基础安全防护能够降低基本攻击造成的伤害，利用既有的规则库和特征库进行防护',
          lists: ['具备主机防病毒和防暴力破解的能力，能够扫描查杀流行病毒，有效防御暴力破解行为;', '配合主机防火墙和入侵防御，实现对访问流量的过滤，抵御网络威胁，满足主机的基本防护需求；', '基础保护级从流量进入主机方面进行防护。'],
          hasImg: true

        },
        {
          id: 2,
          title: '主机加固一增强加固级',
          subtitle: '增强加固级在基础保护级的能力之上',
          lists: ['完善主机系统加固，提高整体防护水平;', '加强WebShell检测能力，对后门攻击进行有效检测查杀，利用黑白名单进一步管控应用程序的安装运行;', '辅以EDR的检测、响应能力，大幅度降低运维难度。'],
          background: 'bg'

        },
        {
          id: 3,
          title: '立体防护级以增强加固级为基础',
          subtitle: '主机基础安全防护能够降低基本攻击造成的伤害，利用既有的规则库和特征库进行防护',
          lists: ['增加资产清点、风险资产发现和安全基线的能力，在事件发生时及时定位处置，减少事件影响范围；', '利用溯源分析能力，明晰整个攻击链条，做好事件总结；', '配合主机行为管理、软件管理和应用程序控制的检测、响应能力，进-步加强运维效率。'],
          stereoscopic: true
        }
      ],
      protect1: [
        {
          id: 1,
          title: '软件管理',
          text: '可作为企业独有的软件管家，统计软件资产、更新软件，保证软件供应安全。'
        },
        {
          id: 2,
          title: '网络可视化管理',
          text: '网络流量和安全威胁展示，起到监控探头的作用，便于运维人员监控主机安全态势。'
        },
        {
          id: 3,
          title: '行为管理',
          text: '基于机器学习的行为模式，梳理机进程的各种操作行为，并监控主机进程成功外连行为、记录日志。'
        }
      ],
      protect2: [
        {
          id: 1,
          title: '安全基线',
          text: '进入主机的“检查卡口”，详细记录各类入侵行为，为用户提供入侵告警。'
        },
        {
          id: 2,
          title: '资产清点',
          text: '主动梳理主机上的基础信息和数字资产，帮助快速了解业务系统情况。'
        },
        {
          id: 3,
          title: '溯源分析',
          text: '安全事件发生后，通过对日志综合分析比对，溯源攻击发生的路径及关键点，分析事件完整过程，找出根本原因。'
        }
      ],
      protect3: [
        {
          id: 1,
          title: '应用程序控制',
          text: '主机的“人脸识别系统”，只有在预置操作系统信任应用程序列表中的应用程序才可以安装运行。'
        },
        {
          id: 2,
          title: '风险发现',
          text: '能进行风险异常检测，类似于“巡逻队”，对主机上的后门、漏洞，弱口令等风险进行检测。 '
        },
        {
          id: 3,
          title: '防端口扫描',
          text: '防止黑客通过端口扫描工具获取服务器敏感信息，降低主机被攻击的风险。 '
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page_html {
  height: 100%;

  .banner {
    width: 100wh;
    height: 550px;

    img {
      width: 100%;
      height: 100%;
    }

    .banner_Title {
      position: absolute;
      top: 15%;
      left: 15%;
      width: 80%;

      .title {
        width: 56%;
        font-size: 54px;
        color: #ffffff;
        font-weight: bold;
      }

      .subtitle {
        width: 85%;
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        margin-top: 50px;
      }
    }
  }

  .contents {
    width: 70%;
    margin: 0 auto;

    .title {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 40px;
    }

    li {
      font-size: 24px;
      font-family: Microsoft YaHei;
      color: #333333;
      line-height: 40px;
    }

    .hasImg {
      width: 100%;
      margin-top: 77px;
      padding-bottom: 100px;

      .top {
        height: 245px;
        width: 100%;
        display: flex;
        justify-content: space-between;

        .content {
          width: 24%;
          height: 100%;

          .title {
            margin-bottom: 27px;
          }

          .text {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
            margin-right: 60px;
          }
        }

        .ImgContent {
          width: 24%;
          height: 100%;
          display: flex;
          justify-content: center;

          img {
            width: 190px;
            height: 190px;
          }

        }

      }

      .lines {
        height: 13px;
        width: 100%;
        display: flex;
        justify-content: space-between;

        .line {
          width: 24%;
          height: 100%;
          background: #A8B3E9;
        }

      }

      .bottom {
        height: 225px;
        width: 100%;
        display: flex;
        justify-content: space-between;

        .content {
          width: 24%;
          height: 100%;

          .title {
            margin: 27px 0 30px;
          }

          .text {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
            margin-right: 60px;
          }
        }

        .ImgContent {
          width: 24%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: flex-end;

          img {
            width: 190px;
            height: 190px;
          }

        }
      }
    }

    .stereoscopic {
      width: 100%;
      margin: 0 auto;

      .stereoscopicLists {
        width: 100%;
        padding-top: 77px;
        height: 839px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 214px;

        .stereoscopicList {
          width: 32%;
          height: 100%;

          border-radius: 30px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;

          .protect {
            width: 336px;
            height: 231px;
            background: #FFFFFF;
            border-radius: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .title {
              font-size: 36px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 40px;
              margin: 17px 0 15px;
            }

            .text {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 40px;
              margin: 0 18px;
            }
          }
        }
      }
    }

  }

  .bg {
    background: #FAFBFF;
    padding: 82px 0 100px;
  }

  .blue {
    background: #3879F6;
  }

  .purple {
    background: #929AD3;
  }

  .babyBlue {
    background: #57ACFE;
  }

}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .page_html .contents {
    width: 85% !important;
  }

  .banner .banner_Title .title {
    font-size: 37px !important;
  }

  .page_html .banner .banner_Title .subtitle,
   .page_html .contents .title,
   .page_html .contents li,
   .page_html .contents .hasImg .top .content .text,
   .page_html .contents .hasImg .bottom .content .text{
    font-size: 20px;
  }
   .page_html .contents .hasImg .top .content .text,
  .page_html .contents .hasImg .bottom .content .text{
        margin-right: 35px;
  }
  .page_html .contents .stereoscopic .stereoscopicLists .stereoscopicList .protect{
    width: 300px;
  }

  .banner{
    height: 400px !important;
  }
}

@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .page_html .contents {
    width: 80% !important;

  }
  .page_html .contents .stereoscopic .stereoscopicLists .stereoscopicList .protect{
    width: 300px;
  }
  .page_html .contents .title,
  .page_html .contents li,
  .page_html .contents .hasImg .top .content .text,
  .page_html .contents .hasImg .bottom .content .text{
    font-size: 22px !important;
  }
  .page_html .contents .hasImg .top .content .text,
  .page_html .contents .hasImg .bottom .content .text{
        margin-right: 35px;
  }
  .banner .banner_Title .title {
    font-size: 40px !important;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 25px;
  }

  .banner{
    height: 450px !important;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {
  .page_html .contents {
    width: 75% !important;
    
  }

  .banner .banner_Title .subtitle {
    font-size: 30px !important;
  }
  .page_html .banner .banner_Title .title{
    font-size: 52px !important;
  }


}
</style>
